import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import FileDrop from "./FormInputs/FileDrop";
import EINInput from "./FormInputs/EINInput";
import { groupedFieldsStyle } from "../TransitionStyles";
import { validateEIN } from "../ValidateFunctions"

FormEINWithFileDrop.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
}

export default function FormEINWithFileDrop({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control, getValues } = useFormContext();

  const fieldArrayMethods = useFieldArray({
    control,
    name: `${fieldName}.files`,
    keyName: '_id',
  });

  const onFileAdded = (files) => {
    files.forEach((res) => {
      fieldArrayMethods.append(res[0]);
    })
  }

  const onFileRemoved = (file) => {
    const fileToRemove = getValues(fieldName)?.files?.findIndex((f) => f.id === file.id);
    fieldArrayMethods.update(fileToRemove, file);
  }

  return <Grid sx={{ backgroundColor: '#f1f3f4cc', ...groupedFieldsStyle }}>
    <Controller
      name={`${fieldName}.answer`}
      control={control}
      rules={{
        validate: value => validateEIN(value)
      }}
      render={() => (<EINInput
          fieldName={`${fieldName}.answer`}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
        />
      )}
    />
    <Controller
      name={`${fieldName}.files`}
      control={control}
      render={() => (<FileDrop
          fieldAttributes={fieldAttributes}
          onFileRemoved={onFileRemoved}
          onFileAdded={onFileAdded}
          files={fieldArrayMethods.fields?.filter((f) => !f.deleteFlag) ?? []}
        />
      )}
    />  
  </Grid>
}